module.exports = __webpack_public_path__ + "media/images/mobile/home/banner11-2dfc643d5b80f358fc9981b5ea777bd7.jpg";